<template>
  <div class="vacancies">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="d-flex justify-content-between">
              <div class="col">
                <h3 class="page-title">Cash Advance</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Expense</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <a
                  class="btn add-btn"
                  @click="openCashRetirement"
                  v-if="!advance.cashRetirement && advance.status == 1"
                  ><i class="fa fa-plus"></i> Open Retirement</a
                >

                <div v-if="advance.cashRetirement">
                  <a
                    class="btn add-btn"
                    @click="openCashRetirement"
                    v-if="
                      advance.cashRetirement.status == 0 &&
                        advance.cashRetirement.approvedBy == null &&
                        isManager
                    "
                    ><i class="fa fa-plus"></i> Approve / Reject</a
                  >
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="accordion" id="accordionExample">
                  <div class="card mb-3">
                    <div class="card-header" id="headingOne">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        <button class="btn collapsed">
                          General
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseOne"
                      class="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="onSubmit">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button
                              class="btn text-primary float-right mr-3"
                              v-if="!advance.cashRetirement"
                            >
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  >Date
                                  <span class="text-danger">*</span></label
                                >
                                <div class="cal-icon">
                                  <datepicker
                                    v-model="advance.date"
                                    bootstrap-styling
                                    class="form-control datetimepicker"
                                    type="date"
                                    :disabled="advance.cashRetirement"
                                  />
                                  <!-- <input class="form-control datetimepicker" type="text"> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label
                                  >Employee
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="advance.requestBy"
                                  :disabled="
                                    currentUser.employee.id !==
                                      advance.requestBy
                                  "
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-12">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model="advance.description"
                                  :disabled="advance.cashRetirement"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>
                                  Amount <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="advance.amount"
                                  :disabled="
                                    advance.cashRetirement ||
                                      advance.status == 1
                                  "
                                />
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <label>
                                  Payment Method
                                  <span class="text-danger">*</span>
                                </label>
                                <select
                                  class="form-control"
                                  v-model="advance.paymentOption"
                                  :disabled="advance.cashRetirement"
                                >
                                  <option>Select Bank</option>
                                  <option value="Cash">Cash</option>
                                  <option value="Transfer">Transfer</option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div
                            class="row"
                            v-if="advance.paymentOption == 'Transfer'"
                          >
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Bank <span class="text-danger">*</span>
                                </label>
                                <select
                                  class="form-control"
                                  v-model="advance.payeeBankName"
                                  :disabled="advance.cashRetirement"
                                >
                                  <option>Select Bank</option>
                                  <option
                                    v-for="item in banks"
                                    :key="item.lookupValue"
                                    :value="item.lookupDescription"
                                  >
                                    {{ item.lookupDescription }}
                                  </option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Account Number
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="advance.payeeAccountNumber"
                                  :disabled="advance.cashRetirement"
                                />
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label>
                                  Payee Account Name
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  v-model="advance.payeeAccountName"
                                  type="text"
                                  class="form-control"
                                  :disabled="advance.cashRetirement"
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="advance.cashRetirement">
                    <div class="card-header" id="headingTwo">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="true"
                        aria-controls="collapseTwo"
                      >
                        <button class="btn collapsed">
                          Cash Retirement
                        </button>
                        <span class="collapsed menu-arrow">
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseTwo"
                      class="collapse show"
                      aria-labelledby="headingTwo"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <form @submit.prevent="onSubmitCashRetirement">
                          <div class="d-flex justify-content-between mt-1">
                            <div></div>
                            <button
                              class="btn text-primary float-right mr-3"
                              v-if="advance.cashRetirement.status != 1"
                            >
                              <i class="la la-check"></i> Save
                            </button>
                          </div>
                          <hr class="mt-1" />
                          <div class="row">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Date
                                  <span class="text-danger">*</span></label
                                >
                                <div class="cal-icon">
                                  <datepicker
                                    v-model="advance.cashRetirement.date"
                                    bootstrap-styling
                                    class="form-control datetimepicker"
                                    type="date"
                                    disabled
                                  />
                                  <!-- <input class="form-control datetimepicker" type="text"> -->
                                </div>
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label
                                  >Retired By
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  placeholder="Select Employee"
                                  class="form-control"
                                  v-model.trim="
                                    advance.cashRetirement.retiredBy
                                  "
                                  disabled
                                >
                                  <option disabled>Select Staff</option>
                                  <option
                                    v-for="member in employees"
                                    :key="member.id"
                                    :value="member.id"
                                  >
                                    {{
                                      member.lastName + " " + member.firstName
                                    }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-10">
                              <div class="form-group">
                                <label
                                  >Description
                                  <span class="text-danger">*</span></label
                                >
                                <textarea
                                  type="text"
                                  rows="5"
                                  cols="7"
                                  class="form-control"
                                  v-model="
                                    advance.cashRetirement.postingDescription
                                  "
                                  :disabled="advance.cashRetirement.status != 1"
                                >
                                </textarea>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-5">
                              <div class="form-group">
                                <label>
                                  Retired Amount
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="advance.cashRetirement.retiredAmount"
                                  disabled
                                />
                              </div>
                            </div>
                            <div class="col-md-5">
                              <div class="form-group">
                                <label>
                                  Reimbursement Amount
                                  <span class="text-danger">*</span>
                                </label>
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="
                                    advance.cashRetirement.reimburseAmount
                                  "
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-3" v-if="advance.cashRetirement">
                    <div class="card-header" id="headingThree">
                      <h5
                        class="mb-0 d-flex justify-content-between collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        <button class="btn collapsed">
                          Cash Retirement Lines ({{
                            advance.cashRetirement.cashRetirementLines &&
                              advance.cashRetirement.cashRetirementLines.length
                          }})
                        </button>
                        <span
                          class="collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          <i class="la la-chevron-down icon-dropdown"></i>
                        </span>
                      </h5>
                    </div>

                    <div
                      id="collapseThree"
                      class="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordionExample"
                    >
                      <div class="card-body">
                        <div class="row">
                          <a
                            @click="openDialogMeasurement"
                            class="btn text-primary ml-3"
                          >
                            <i class="la la-plus"></i> Add
                          </a>
                        </div>
                        <hr />

                        <!-- Add Measurement Modal -->
                        <v-dialog v-model="dialogMeasurement" max-width="725px">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Add Cash Retirement Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onSubmitMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Transaction Date
                                            <span class="text-danger">*</span>
                                          </label>
                                          <div class="cal-icon">
                                            <datepicker
                                              v-model="
                                                cashRetirementLine.transactionDate
                                              "
                                              bootstrap-styling
                                              class="form-control datetimepicker"
                                              type="date"
                                            />
                                            <!-- <input class="form-control datetimepicker" type="text"> -->
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="cashRetirementLine.amount"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      
                            <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Expense Type
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  class="form-control"
                                  v-model="cashRetirementLine.glAccount"
                                >
                                  <option>Select Type</option>
                                  <option
                                    v-for="item in expenseTypes"
                                    :key="item.id"
                                    :value="item.glAccount"
                                    >{{ item.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.description
                                            "
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Quantity
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.quantity
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Unit Cost
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.unitCost
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /Add Measurement Modal -->

                        <!-- edit Measurement Modal -->
                        <v-dialog
                          v-model="dialogEditMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5 class="modal-title">
                                Edit Cash Retirement Line
                              </h5>
                              <button
                                type="button"
                                class="close"
                                @click="closeEditMeasurement"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <form @submit.prevent="onEditMeasurement">
                                <div class="row">
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-danger alert-dismissible fade show"
                                      role="alert"
                                      v-if="error"
                                    >
                                      <strong>Error!</strong> {{ error }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                  <div class="col-md-12">
                                    <div
                                      class="alert alert-success alert-dismissible fade show"
                                      role="alert"
                                      v-if="message"
                                    >
                                      <strong>Success!</strong> {{ message }}
                                      <button
                                        type="button"
                                        class="close"
                                        data-dismiss="alert"
                                        aria-label="Close"
                                      >
                                        <span aria-hidden="true">&times;</span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-sm-12">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Transaction Date
                                            <span class="text-danger">*</span>
                                          </label>
                                          <div class="cal-icon">
                                            <datepicker
                                              v-model="
                                                cashRetirementLine.transactionDate
                                              "
                                              bootstrap-styling
                                              class="form-control datetimepicker"
                                              type="date"
                                            />
                                            <!-- <input class="form-control datetimepicker" type="text"> -->
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                                        <div class="form-group">
                                          <label>
                                            Amount
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            v-model="cashRetirementLine.amount"
                                            type="text"
                                            class="form-control"
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-4">
                              <div class="form-group">
                                <label
                                  >Expense Type
                                  <span class="text-danger">*</span></label
                                >
                                <select
                                  class="form-control"
                                  v-model="cashRetirementLine.glAccount"
                                >
                                  <option>Select Type</option>
                                  <option
                                    v-for="item in expenseTypes"
                                    :key="item.id"
                                    :value="item.glAccount"
                                    >{{ item.name }}</option
                                  >
                                </select>
                              </div>
                            </div>
                                      <div class="col-md-12">
                                        <div class="form-group">
                                          <label>
                                            Description
                                            <span class="text-danger">*</span>
                                          </label>
                                          <textarea
                                            type="text"
                                            rows="5"
                                            cols="7"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.description
                                            "
                                          >
                                          </textarea>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Quantity
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.quantity
                                            "
                                          />
                                        </div>
                                      </div>
                                      <div class="col-md-6">
                                        <div class="form-group">
                                          <label>
                                            Unit Cost
                                            <span class="text-danger">*</span>
                                          </label>
                                          <input
                                            type="number"
                                            class="form-control"
                                            v-model="
                                              cashRetirementLine.unitCost
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="submit-section">
                                  <button class="btn btn-primary submit-btn">
                                    Submit
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </v-dialog>
                        <!-- /edit Measurement Modal -->

                        <v-dialog
                          v-model="dialogDeleteMeasurement"
                          max-width="725px"
                        >
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="form-header">
                                <h3>Delete</h3>
                                <p>Are you sure want to delete this?</p>
                              </div>
                              <div class="modal-btn delete-action">
                                <div class="row">
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary continue-btn"
                                      @click="onDeleteMeasurement"
                                      >Delete</a
                                    >
                                  </div>
                                  <div class="col-6">
                                    <a
                                      class="btn btn-primary cancel-btn"
                                      @click="closeDeleteMeasurement"
                                      >Cancel</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-dialog>

                        <!----Datatable-->
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <v-data-table
                                :headers="headersM"
                                :items="
                                  advance.cashRetirement.cashRetirementLines
                                "
                                sort-by=""
                                class="elevation-1"
                              >
                                <template v-slot:[`item.actions`]="{ item }">
                                  <div class="dropdown dropdown-action">
                                    <a
                                      href="#"
                                      class="action-icon dropdown-toggle"
                                      data-toggle="dropdown"
                                      v-if="advance.cashRetirement.status != 1"
                                      aria-expanded="false"
                                      ><i class="material-icons"
                                        >more_vert</i
                                      ></a
                                    >
                                    <div
                                      class="dropdown-menu dropdown-menu-right"
                                    >
                                      <a
                                        class="dropdown-item"
                                        @click="openDialogEditMeasurement(item)"
                                        ><i class="fa fa-pencil m-r-5"></i>
                                        Edit</a
                                      >
                                      <a
                                        class="dropdown-item"
                                        @click="openDeleteMeasurement(item)"
                                        ><i class="fa fa-trash-o m-r-5"></i>
                                        Delete</a
                                      >
                                    </div>
                                  </div>
                                </template>
                              </v-data-table>
                            </div>
                          </div>
                        </div>
                        <!---/Datatable-->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
        </div>
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { authenticationService } from "@/services/authenticationService";
import { performanceService } from "@/services/performanceService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";
import { required, sameAs } from "vuelidate/lib/validators";
import vueDynamicForms from "vuejs-dynamic-forms";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker,
    vueDynamicForms
  },
  data() {
    return {
      advanceId: this.$route.params.id,
      dialogMeasurement: false,
      dialogEditMeasurement: false,
      dialogDeleteMeasurement: false,
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue,
      headersM: [
        {
          text: "Description",
          align: "start",
          value: "description"
        },
        { text: "Trans. Date", value: "transactionDate" },
        { text: "Quantity", value: "quantity" },
        { text: "Unit Cost", value: "unitCost" },
        { text: "Total Amount", value: "amount" },
        { text: "", value: "actions", sortable: false }
      ],
      banks: [],
      employees: [],
      expenseTypes: [],
      isManager: false,
      advance: {
        date: new Date(),
        requestBy: 0,
        description: "",
        paymentOption: "",
        payeeName: "",
        payeeBankName: "",
        payeeAccountNumber: "",
        amount: 0,
        cashRetirement: {
          cashRetirementLines: []
        }
      },
      cashRetirementLine: {},
      message: "",
      error: ""
    };
  },
  methods: {
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },
    getBanks() {
      organizationService.getBanks().then(o => (this.banks = o));
    },
    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getCashAdvance() {
      employeeService.getCashAdvanceById(this.advanceId).then(
        model => {
          console.log(model);
          this.advance = model;
        },
        error => {
          error = error;
        }
      );
    },
    onSubmit() {
      this.submitted = true;

      this.loading = true;
      if (!this.advanceId) {
        this.advance.cashRetirement = null;
        employeeService.addCashAdvance(this.advance).then(
          id => {
            this.$router.push("/cash-advance");
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      } else {
        employeeService.updateCashAdvance(this.advance).then(
          id => {
            this.getCashAdvance();
          },
          error => {
            this.error = error;
            this.loading = false;
          }
        );
      }
    },
    openCashRetirement() {
      var req = {
        cashAdvanceId: this.advanceId,
        date: new Date(),
        retiredBy: this.currentUser.employee.id,
        postingDescription: "Retirement for cash advance"
      };
      employeeService.addCashRetirement(req).then(
        model => {
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onSubmitCashRetirement() {
      employeeService.updateCashRetirement(this.advance.cashRetirement).then(
        model => {
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    getTypes() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getExpenseType(companyId).then(
        model => {
          this.expenseTypes = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    onSubmitMeasurement() {
      this.cashRetirementLine.cashRetirementId = this.advance.cashRetirementId;
      employeeService.addCashRetirementLine(this.cashRetirementLine).then(
        model => {
          this.closeMeasurement();
          this.cashRetirementLine = {};
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onEditMeasurement() {
      employeeService.updateCashRetirementLine(this.cashRetirementLine).then(
        model => {
          this.closeEditMeasurement();
          this.cashRetirementLine = {};
          this.getCashAdvance();
        },
        error => {
          this.error = error;
        }
      );
    },
    onDeleteMeasurement() {
      employeeService
        .removeCashRetirementLine(this.cashRetirementLine.id)
        .then(model => {
          this.getCashAdvance();
          this.cashRetirementLine = {};
          this.closeDeleteMeasurement();
        });
    },
    closeDeleteMeasurement() {
      this.dialogDeleteMeasurement = false;
    },
    closeMeasurement() {
      this.dialogMeasurement = false;
    },
    closeEditMeasurement() {
      this.dialogEditMeasurement = false;
    },
    openDialogMeasurement() {
      this.message = "";
      this.error = "";
      this.dialogMeasurement = true;
    },
    openDialogEditMeasurement(item) {
      this.message = "";
      this.error = "";
      console.log(`item`, item);
      this.cashRetirementLine = item;
      this.dialogEditMeasurement = true;
    },
    openDeleteMeasurement(item) {
      this.cashRetirementLine = item;
      this.dialogDeleteMeasurement = true;
    }
  },
  mounted() {
    this.isEmployeeManager();
    this.getEmployees();
    this.getBanks();
    this.getCashAdvance();
    this.getTypes()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/CashAdvance/detail.vue